/**
 * 페이지 관련 상수 정의
 */

export const PAGE_VIEW = {
    CARD: "card",
    TABLE: "table",
};

export const PAGE_SORT_ORDER = {
    ASC: "asc",
    DESC: "desc",
};

export const PAGE_PERIOD = {
    UNLIMITED: "unlimited",
    RANGE: "range",
};

export const PAGE_CONDITION_CONNECTOR = {
    AND: "and",
    OR: "or",
};

export const PAGE_CONDITION_OPERATOR = {
    EQUAL: "=",
    NOT_EQUAL: "!=",
    CONTAINS: "contains",
    BETWEEN: "between"
};